import React from 'react'
import { Body } from 'shared-global-ec-uikit/components/dist/react/esm/components/body'
import { LinkText } from 'shared-global-ec-uikit/components/dist/react/esm/components/link-text'
import { FormattedMessage } from 'react-intl'
import { Display } from 'shared-global-ec-uikit/components/dist/react/esm'

const Recruitment = (props: any) => {
  const {
    storeInfo: {
      recruitFlag,
      recruitLinkUrl,
      regionalRecruitFlag,
      regionalRecruitLinkUrl,
    },
  } = props

  const showRecruitLink = !!recruitFlag && recruitLinkUrl
  const showRegionalRecruitLink =
    !!regionalRecruitFlag && regionalRecruitLinkUrl

  return showRegionalRecruitLink || showRecruitLink ? (
    <>
      <Display
        color="primary-dark"
        element="p"
        maxLinesEllipsis={0}
        textAlign="left"
        textTransform="normal"
        variant="display4"
      >
        <Body
          element="p"
          className="fr-ec-mb-spacing-04"
          color="primary-dark"
          variant="display4"
        >
          <FormattedMessage id="text_hiringinfo" />
        </Body>
      </Display>
      {showRegionalRecruitLink && (
        <div className="fr-ec-mb-spacing-04">
          <LinkText
            element="a"
            href={regionalRecruitLinkUrl}
            variant="standalone"
            target="_blank"
            ecRenewal
          >
            <FormattedMessage id="text_regular_employee" />
          </LinkText>
        </div>
      )}
      {showRecruitLink && (
        <div className="fr-ec-mb-spacing-04">
          <LinkText
            element="a"
            href={recruitLinkUrl}
            variant="standalone"
            target="_blank"
            ecRenewal
          >
            <FormattedMessage id="text_storestaff_hiring" />
          </LinkText>
        </div>
      )}
    </>
  ) : null
}

export default Recruitment
